import { defineComponent as S, computed as a, openBlock as d, createBlock as H, resolveDynamicComponent as h, normalizeStyle as y, withCtx as b, createElementBlock as x } from "vue";
import { KUI_ICON_SIZE_50 as l } from "./kong-icons.es1628.js";
const z = ["aria-hidden"], c = '<path d="M3.75 22C3.53333 22 3.35417 21.9292 3.2125 21.7875C3.07083 21.6458 3 21.4667 3 21.25C3 21.0333 3.07083 20.8542 3.2125 20.7125C3.35417 20.5708 3.53333 20.5 3.75 20.5H5.5V19.75H4.75C4.53333 19.75 4.35417 19.6792 4.2125 19.5375C4.07083 19.3958 4 19.2167 4 19C4 18.7833 4.07083 18.6042 4.2125 18.4625C4.35417 18.3208 4.53333 18.25 4.75 18.25H5.5V17.5H3.75C3.53333 17.5 3.35417 17.4292 3.2125 17.2875C3.07083 17.1458 3 16.9667 3 16.75C3 16.5333 3.07083 16.3542 3.2125 16.2125C3.35417 16.0708 3.53333 16 3.75 16H6C6.28333 16 6.52083 16.0958 6.7125 16.2875C6.90417 16.4792 7 16.7167 7 17V18C7 18.2833 6.90417 18.5208 6.7125 18.7125C6.52083 18.9042 6.28333 19 6 19C6.28333 19 6.52083 19.0958 6.7125 19.2875C6.90417 19.4792 7 19.7167 7 20V21C7 21.2833 6.90417 21.5208 6.7125 21.7125C6.52083 21.9042 6.28333 22 6 22H3.75ZM3.75 15C3.53333 15 3.35417 14.9292 3.2125 14.7875C3.07083 14.6458 3 14.4667 3 14.25V12.25C3 11.9667 3.09583 11.7292 3.2875 11.5375C3.47917 11.3458 3.71667 11.25 4 11.25H5.5V10.5H3.75C3.53333 10.5 3.35417 10.4292 3.2125 10.2875C3.07083 10.1458 3 9.96667 3 9.75C3 9.53333 3.07083 9.35417 3.2125 9.2125C3.35417 9.07083 3.53333 9 3.75 9H6C6.28333 9 6.52083 9.09583 6.7125 9.2875C6.90417 9.47917 7 9.71667 7 10V11.75C7 12.0333 6.90417 12.2708 6.7125 12.4625C6.52083 12.6542 6.28333 12.75 6 12.75H4.5V13.5H6.25C6.46667 13.5 6.64583 13.5708 6.7875 13.7125C6.92917 13.8542 7 14.0333 7 14.25C7 14.4667 6.92917 14.6458 6.7875 14.7875C6.64583 14.9292 6.46667 15 6.25 15H3.75ZM5.25 8C5.03333 8 4.85417 7.92917 4.7125 7.7875C4.57083 7.64583 4.5 7.46667 4.5 7.25V3.5H3.75C3.53333 3.5 3.35417 3.42917 3.2125 3.2875C3.07083 3.14583 3 2.96667 3 2.75C3 2.53333 3.07083 2.35417 3.2125 2.2125C3.35417 2.07083 3.53333 2 3.75 2H5.25C5.46667 2 5.64583 2.07083 5.7875 2.2125C5.92917 2.35417 6 2.53333 6 2.75V7.25C6 7.46667 5.92917 7.64583 5.7875 7.7875C5.64583 7.92917 5.46667 8 5.25 8ZM10 19C9.71667 19 9.47917 18.9042 9.2875 18.7125C9.09583 18.5208 9 18.2833 9 18C9 17.7167 9.09583 17.4792 9.2875 17.2875C9.47917 17.0958 9.71667 17 10 17H20C20.2833 17 20.5208 17.0958 20.7125 17.2875C20.9042 17.4792 21 17.7167 21 18C21 18.2833 20.9042 18.5208 20.7125 18.7125C20.5208 18.9042 20.2833 19 20 19H10ZM10 13C9.71667 13 9.47917 12.9042 9.2875 12.7125C9.09583 12.5208 9 12.2833 9 12C9 11.7167 9.09583 11.4792 9.2875 11.2875C9.47917 11.0958 9.71667 11 10 11H20C20.2833 11 20.5208 11.0958 20.7125 11.2875C20.9042 11.4792 21 11.7167 21 12C21 12.2833 20.9042 12.5208 20.7125 12.7125C20.5208 12.9042 20.2833 13 20 13H10ZM10 7C9.71667 7 9.47917 6.90417 9.2875 6.7125C9.09583 6.52083 9 6.28333 9 6C9 5.71667 9.09583 5.47917 9.2875 5.2875C9.47917 5.09583 9.71667 5 10 5H20C20.2833 5 20.5208 5.09583 20.7125 5.2875C20.9042 5.47917 21 5.71667 21 6C21 6.28333 20.9042 6.52083 20.7125 6.7125C20.5208 6.90417 20.2833 7 20 7H10Z" fill="currentColor"/>', $ = /* @__PURE__ */ S({
  __name: "ListOrderedIcon",
  props: {
    /** The accessibility text provided to screen readers */
    title: {
      type: String,
      required: !1,
      default: ""
    },
    /** The icon color. Defaults to `currentColor` which inherits text color from the parent element */
    color: {
      type: String,
      required: !1,
      default: "currentColor"
    },
    /** The CSS display property for the icon. Defaults to `block` */
    display: {
      type: String,
      required: !1,
      default: "block"
    },
    /** Whether the icon is just eye-candy or is meaningful to the page (should screen-readers ignore the icon?) */
    decorative: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /** The icon size */
    size: {
      type: [Number, String],
      required: !1,
      default: l,
      // if setting to the imported const fails, just pass a number of 24 as the default.
      validator: (i) => {
        if (typeof i == "number" && i > 0)
          return !0;
        if (typeof i == "string") {
          const e = String(i).replace(/px/gi, ""), r = Number(e);
          if (r && !isNaN(r) && Number.isInteger(r) && r > 0)
            return !0;
        }
        return !1;
      }
    },
    /** The HTML tag to utilize for the icon's wrapper element. Defaults to `span` */
    as: {
      type: String,
      required: !1,
      default: "span"
    },
    /**
     * A boolean to disable prefixing any internal SVG ids with a unique string which is done to resolve the potential for multiple SVG instances on the same page and the SVG utilizing the same ids and references internally (e.g. in the `<defs>` tag).
     * Typically only set to `true` during snapshot testing.
     * Defaults to `false`.
     */
    staticIds: {
      type: Boolean,
      default: !1
    }
  },
  setup(i) {
    const e = i, r = a(() => {
      if (typeof e.size == "number" && e.size > 0)
        return `${e.size}px`;
      if (typeof e.size == "string") {
        const n = String(e.size).replace(/px/gi, ""), t = Number(n);
        if (t && !isNaN(t) && Number.isInteger(t) && t > 0)
          return `${t}px`;
      }
      return l;
    }), u = a(() => ({
      boxSizing: "border-box",
      color: e.color,
      display: e.display,
      flexShrink: "0",
      height: r.value,
      lineHeight: "0",
      width: r.value,
      pointerEvents: e.decorative ? "none" : void 0
    })), g = (n) => {
      const t = {}, v = Math.random().toString(36).substring(2, 12);
      return n.replace(/id="([^"]+)"/g, (s, o) => {
        const C = `${v}-${o}`;
        return t[o] = C, `id="${C}"`;
      }).replace(/#([^\s^")]+)/g, (s, o) => t[o] ? `#${t[o]}` : s);
    }, p = {
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;",
      "&": "&amp;"
    }, f = (n) => n.replace(/[<>"'&]/g, (t) => p[t]), m = `${e.title ? `<title data-testid="kui-icon-svg-title">${f(e.title)}</title>` : ""}${e.staticIds ? c : g(c)}`;
    return (n, t) => (d(), H(h(i.as), {
      "aria-hidden": i.decorative ? "true" : void 0,
      class: "kui-icon list-ordered-icon",
      "data-testid": "kui-icon-wrapper-list-ordered-icon",
      style: y(u.value),
      tabindex: i.decorative ? "-1" : void 0
    }, {
      default: b(() => [
        (d(), x("svg", {
          "aria-hidden": i.decorative ? "true" : void 0,
          "data-testid": "kui-icon-svg-list-ordered-icon",
          fill: "none",
          height: "100%",
          role: "img",
          viewBox: "0 0 24 24",
          width: "100%",
          xmlns: "http://www.w3.org/2000/svg",
          innerHTML: m
        }, null, 8, z))
      ]),
      _: 1
    }, 8, ["aria-hidden", "style", "tabindex"]));
  }
});
export {
  $ as default
};
